import { Component } from 'preact';

import ViewContext from '../../view/ViewContext';
import Button from '../button/Button';

const CONTROL_QUERY_PARAMETER = 'ribbon--control';
const EVENT_NAME = 'ribbon';

export default class Control extends Component {
	static get contextType() {
		return ViewContext;
	}

	componentDidMount() {
		if (window.location.search.includes(CONTROL_QUERY_PARAMETER)) {
			this.onClick();
		}
	}

	render() {
		const { control } = this.context.props;

		if (!control) {
			return null;
		}

		return (
			<div className='ribbon-control'>
				<Button
					action={CONTROL_QUERY_PARAMETER}
					onClick={() => this.onClick()}
					data-dot='lista_tlacitko'
				>
					{this._renderIcon()}
					<span className='ribbon-control__label'>{control.label}</span>
				</Button>
			</div>
		);
	}

	_renderIcon() {
		const { control } = this.context.props;

		if (!control.icon || !control.icon.src) {
			return null;
		}

		return <img className='ribbon-control__icon' src={control.icon.src} alt='Ikona' />;
	}

	onClick() {
		window.dispatchEvent(
			new CustomEvent(EVENT_NAME, { detail: { controlClicked: true } })
		);
	}
}
